/**
 * Why a {@link RetiredTechnicalSecuritySystemModel} row was retired (#613).
 *
 * Mirrors the C# `ShardTssHistory.Reason` enum exactly — Newtonsoft serialises it as the bare string, not a
 * number, so these values are the wire contract, not just a display aid.
 */
export enum RetiredTechnicalSecuritySystemReason {
  /** The provider reported the TSE as `DISABLED` (the common case — an inactive TSE fiskaly switched off). */
  Disabled = "Disabled",
  /** The provider reported the TSE as `DEFECTIVE`. */
  Defective = "Defective",
  /** The provider withdrew the TSE (e.g. a contract/quota change on the provider side). */
  Evicted = "Evicted",
  /** The provider has no record of the TSE at all (`DELETED`). */
  Deleted = "Deleted",
  /** The provider answered `E_TSS_NOT_FOUND` for the TSE id. */
  NotFound = "NotFound",
  /**
   * (#910) A 403 for the TSE id, but the id is genuinely absent from the stored key's own TSS list — the
   * shard's TSS now belongs to a different fiskaly organisation than the stored credentials (the typical
   * aftermath of a TEST→LIVE credential switch). Appended, never renumber.
   */
  ForeignOrganisation = "ForeignOrganisation"
}

/** German display copy for {@link RetiredTechnicalSecuritySystemReason} — Sie-form, matches the TSE page. */
export class RetiredTechnicalSecuritySystemReasonHelper {
  public static toDisplayString(reason: RetiredTechnicalSecuritySystemReason | string): string {
    switch (reason) {
      case RetiredTechnicalSecuritySystemReason.Disabled:
        return "Vom Anbieter deaktiviert";
      case RetiredTechnicalSecuritySystemReason.Defective:
        return "Vom Anbieter als defekt gemeldet";
      case RetiredTechnicalSecuritySystemReason.Evicted:
        return "Vom Anbieter entzogen";
      case RetiredTechnicalSecuritySystemReason.Deleted:
        return "Beim Anbieter gelöscht";
      case RetiredTechnicalSecuritySystemReason.NotFound:
        return "Beim Anbieter nicht mehr auffindbar";
      case RetiredTechnicalSecuritySystemReason.ForeignOrganisation:
        return "Gehörte zu einer anderen fiskaly-Organisation";
      default:
        return "Unbekannt";
    }
  }
}
